import {AdvertApiResponse, ApiResponse} from "../types/ApiResponse";
import {deserialize} from "deserialize-json-api";
import {Advert} from "../types/Advert";
import {RequestParams} from "./RequestParams";
import {Make} from "../types/Make";
import {Location} from "../types/Location";

const token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxMCIsImp0aSI6IjBkNzA3MWYyNDkzMDA3OGIwNDcxYjcyMTc4YjEzZmI2NmFhYWIyNmJiZjBiMjhlOTc3MjBkYTkzZDhkYjkyZDEwMzVjZmQ1YWU3NDIwYjIwIiwiaWF0IjoxNjgxMTkwNTgzLjc0MDI4MiwibmJmIjoxNjgxMTkwNTgzLjc0MDI4OCwiZXhwIjoxNzEyODEyOTgzLjczNjYwNywic3ViIjoiIiwic2NvcGVzIjpbXX0.ipJxITdsxTXa812OsbjTyT4AXj7cIdwtL4-AiRPVT5EV39WieqsTNoDfoHFJbl3e5MFv5nP6dhU4oMdgdtXiFnykaZQD9875k4IFCpCZgu3Foh88Ed-pCHPhfED0IRVXoZZ8RP1MbgucbR8ST812-13UT7vwTVktiB1aApcySlWocsOrUXLS8lBr7zJv9dIwOxAyOKEip4pHZZWiAkL7x5Zy_A_3BOQuopLogKxcee12PEBGVGkCQL2_fUhHtkocwAgaJ85n9SvWfZ5W9l1l7E2Vyb-O6ZMOEGwZtmdZOO_Sq-FCFKJk8So9i0VFnVgCUAecTdPx91_lHOXDYptbsB899kVwmZPLfe_jJkp9SvnPWDiwL4aKXQGO7BGW20nXWSmFE1yJ0rl5XMab_mj6BG1gjBmj1ISXCaXLpgVzC9xSxvTk4oeA0ry9HKv5YRNkUZFess02EpQ0lb9KI98bNATpI2V27AGBDSCjVSVODPcOfjMl_rpuCnYPCIPB55LQhbdH6-7VBSuldpJwgsacLf0GbyjqTWXU6XdNQJlzJZ6lHi9tK9l51FWNfrRQAkGVsRflZx5WPFNDF_p4qbjip0DSIkYRux7q723y_12S-S6ziNi_hmz2RYCGQnYUkG8AHxUlMEOuHWN_Xi2Og2YLLPlc0sww6p7Lm6C-j0wzDtw";
const API_URL = "https://choosemycar.com/api";

const apiRequest = async (endpoint: string, method: string = "GET") => {
    return await fetch(`${API_URL}${endpoint}`, {
        method: method,
        headers: {
            "Accept": "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
            "Authorization": "Bearer " + token,
        }
    });
}

export async function fetchAdverts(params: RequestParams): Promise<AdvertApiResponse<Advert>> {
    const res = await apiRequest(`/adverts/search${params.toApiString()}`)
    return deserialize(await res.json());
}

export async function fetchMakes(): Promise<ApiResponse<Make>> {
    const res = await apiRequest(`/makes?filter[standard]=true`);
    return deserialize(await res.json());
}

export async function fetchLocations(): Promise<ApiResponse<Location>> {
    const res = await apiRequest(`/locations`);
    return deserialize(await res.json());
}
